/*
 *==================================================
 * Licensed Materials - Property of HCL Technologies
 *
 * HCL Commerce
 *
 * (C) Copyright HCL Technologies Limited 2020
 *
 *==================================================
 */
import { DAYS, MONTHS } from "../constants/common";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

const date = new Date("2023-09-15");

const StyledToday = styled.div`
  h3 {
    font-size: 40px;
    font-weight: 300;
    text-transform: uppercase;
    margin: 0;
  }
  p {
    font-size: 18px;
    font-weight: 500;
  }
`;

const Today = () => {
  const { t } = useTranslation();

  return (
    <StyledToday>
      <h3>{t("Common.Today")}</h3>
      <p>
        {DAYS[date.getDay()] +
          ", " +
          date.getDate() +
          " de " +
          MONTHS[date.getMonth()] +
          ", " +
          date.getUTCFullYear()}
      </p>
    </StyledToday>
  );
};

export default Today;
